import * as React from 'react'

import { MATRIX_MAX_COLUMNS } from '../utils/constants'

export function calculateSpan(
  optionsLength: number,
  type?: 'open_ended'
): [number, number] {
  if (type === 'open_ended') {
    return [1, optionsLength + 1]
  }

  if (optionsLength === 1 || optionsLength === 2) {
    return [MATRIX_MAX_COLUMNS - optionsLength, MATRIX_MAX_COLUMNS]
  }
  if (optionsLength > MATRIX_MAX_COLUMNS) {
    const totalColSpan = Math.floor(optionsLength * 1.5)
    const firstColSpan = totalColSpan - optionsLength
    return [firstColSpan, totalColSpan]
  }
  return [optionsLength, optionsLength * 2]
}

export function useMatrixColumnSpans(
  optionsLength: number,
  type?: 'open_ended'
): [number, number] {
  const [columnSpans, setColumnSpans] = React.useState(() =>
    calculateSpan(optionsLength, type)
  )

  React.useEffect(() => {
    setColumnSpans(() => calculateSpan(optionsLength, type))
  }, [optionsLength, type])

  return columnSpans
}
